import { type IconButtonProps } from "@clipboard-health/ui-components";
import type { IconType } from "@clipboard-health/ui-components/src/components/CbhIcon";
import { Box } from "@mui/material";
import { IconButton } from "@src/appV2/redesign/components/IconButton";

export function AbsoluteSmallButton(
  props: {
    onClick: () => void;
    position: "right" | "left";
    label?: string;
    iconType: IconType;
  } & Partial<IconButtonProps>
) {
  const { onClick, position, label, ...buttonProps } = props;

  return (
    <Box
      position="absolute"
      top={(theme) => theme.spacing(6)}
      right={position === "right" ? (theme) => theme.spacing(6) : undefined}
      left={position === "left" ? (theme) => theme.spacing(6) : undefined}
      sx={(theme) => ({ zIndex: theme.zIndex.modal + 1 })}
    >
      <IconButton
        size="small"
        variant="outlined"
        aria-label={label}
        onClick={onClick}
        {...buttonProps}
      />
    </Box>
  );
}
